document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.testimonial-slider__container');
  if (slider && typeof Swiper !== 'undefined') {
    new Swiper(slider, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.testimonial-slider__nav--next',
        prevEl: '.testimonial-slider__nav--prev'
      },
      scrollbar: {
        el: '.testimonial-slider__progress',
        draggable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2
        }
      }
    });
  }
});
